import React from 'react';
import { useTranslation } from 'react-i18next';

import callIcon from '@/assets/icons/how-it-works/material-symbols_call-outline.svg';
import documentIcon from '@/assets/icons/how-it-works/mi_document-check.svg';
import smileIcon from '@/assets/icons/how-it-works/lucide_smile.svg';
import arrow from '@/assets/icons/how-it-works/arrow.svg';
import arrowMedium from '@/assets/icons/how-it-works/arrow_medium.svg';
import arrowSmall from '@/assets/icons/how-it-works/arrow_small.svg';

import { useScreenType } from '@/hooks/useScreenType';

import { Container } from '@/components/Container';
import { Title } from '@/components/Title';
import { BenefitCard } from '@/components/BenefitCard';
import { Cloud } from '@/components/Cloud';

import styles from './HowItWorks.module.scss';

const STEP_CARDS_ICONS = [
  {
    iconSrc: callIcon,
    iconAlt: 'Call',
  },
  {
    iconSrc: documentIcon,
    iconAlt: 'Document',
  },
  {
    iconSrc: smileIcon,
    iconAlt: 'Smile',
  },
];

export function HowItWorks() {
  const { t } = useTranslation('howItWorks');

  const stepCardsLocales = t('stepCards', { returnObjects: true }) as {
    title: string;
    description: string;
  }[];
  const stepCards = STEP_CARDS_ICONS.map((icon, index) => ({
    iconSrc: icon.iconSrc,
    iconAlt: icon.iconAlt,
    title: stepCardsLocales[index].title,
    description: stepCardsLocales[index].description,
  }));

  const { screenType } = useScreenType();

  const arrowIcon = (() => {
    if (screenType === 'desktop') return arrow;
    if (screenType === 'tablet') return arrowSmall;
    return arrowMedium;
  })();

  return (
    <section className={styles.howItWorks}>
      <Cloud className={styles.howItWorks__cloud1} variant={2} />
      <Cloud className={styles.howItWorks__cloud2} variant={3} />
      <Container className={styles.howItWorks__container}>
        <Title className={styles.howItWorks__title}>{t('title')}</Title>
        <div className={styles.howItWorks__cards}>
          {stepCards.map((card, index) => (
            <React.Fragment key={index}>
              <BenefitCard
                className={styles.howItWorks__card}
                iconSrc={card.iconSrc}
                iconAlt={card.iconAlt}
                title={card.title}
                description={card.description}
              />
              {index < stepCards.length - 1 && (
                <div className={styles.howItWorks__arrow}>
                  <img src={arrowIcon} alt="Arrow" />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </Container>
    </section>
  );
}
